import { Component, forwardRef, HostListener, input, Input, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { Sponsor } from '../../../core/models/ordering/sponsor.model';
import { CustomCheckboxComponent } from "../../custom-checkbox/custom-checkbox.component";

@Component({
  selector: 'cwo-fundraiser-sponsor-entry',
  standalone: true,
  imports: [FormsModule, CustomCheckboxComponent],
  templateUrl: './fundraiser-sponsor-entry.component.html',
  styleUrl: './fundraiser-sponsor-entry.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FundraiserSponsorEntryComponent),
      multi: true,
    },
  ],
})
export class FundraiserSponsorEntryComponent implements ControlValueAccessor {
  sponsor = input.required<Sponsor>();

  selectedSponsors: Sponsor[] = [];

  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() selected = false;

  readonly sponsorToggled = output<{
    sponsor: Sponsor;
    selected: boolean;
}>();

  onChange = (val: Sponsor[]) => { return val; };
  onTouch = () => { return undefined; };

  @HostListener('focusout')
  onFocusOut() {
    this.onTouch();
  }

  get isSelected(): boolean {
    return this.selected;
  }

  onSponsorToggle(newValue?: boolean) {
    const willBeSelected = typeof newValue === 'boolean' ? newValue : !this.selected;
    this.selected = willBeSelected;

    if (willBeSelected) {
      if (!this.selectedSponsors.some(s => s.name === this.sponsor().name)) {
        this.selectedSponsors = [...this.selectedSponsors, this.sponsor()];
      }
    } else {
      this.selectedSponsors = this.selectedSponsors.filter(s => s.name !== this.sponsor().name);
    }

    this.onChange(this.selectedSponsors);
    this.sponsorToggled.emit({ sponsor: this.sponsor(), selected: willBeSelected });
  }

  writeValue(obj: Sponsor[] | null): void {
    this.selectedSponsors = obj ?? [];
    this.selected = this.selectedSponsors.some(s => s.name === this.sponsor().name);
  }

  registerOnChange(fn: (val: Sponsor[]) => Sponsor[]): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => undefined): void {
    this.onTouch = fn;
  }
}
